import { Component, Input, } from '@angular/core';
import { MapProvider } from '../../providers/map';
import { Field } from '../../model/production/unit/field';
import { FieldUtil } from '../../util/field-util';
import { ILatLng } from '@ionic-native/google-maps';


const HTML_TEMPLATE = `

`;

const CSS_STYLE = `    
fab-camera-target {
    thf-icon {
        font-size: 24px;
        margin-top: 2px;
        margin-left: 10px;
    }
}
`;

/*@Component({
    selector: 'fab-camera-target',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})*/

export class FabCameraTargetComponent {

    @Input('align') align: string;
    @Input('map') map: MapProvider;
    @Input('fields') fields: Field[];
    @Input('callback') callback: Function;
    @Input('navigationMode') navigationMode: boolean;
  
    private _approximate: boolean;
  
    constructor(private _fieldUtil: FieldUtil) {
      this._approximate = false;
    }
  
    async onClick() {
     /* this._approximate = !this._approximate;
  
      if (this._approximate) {
        let currentPosition = <ILatLng>await this.map.getCurrentPosition();
  
        if (currentPosition) {
          this._fieldUtil.getFieldByCurrentLocation(this.map, currentPosition)
            .then(field => {
              let points;
              if (field)
                points = field.polygon;
              else {
                if (this.navigationMode && this.fields.length) {
                  points = this.fields[0].polygon;
                } else {
                  points = currentPosition;
                }
              }
  
              this.map.getMapInstance().animateCamera({
                'target': points,
                'zoom': 19,
                'duration': 2500
              });
              if (this.callback)
                if (field) {
                  this.callback(this._approximate, field);
                } else {
                  if (this.navigationMode && this.fields.length) {
                    this.callback(this._approximate, this.fields[0]);
                  } else {
                    this.callback(this._approximate, null);
                  }
                }
            });
        }
      } else {
        const points = this.fields
          .map(field => field.polygon)
          .reduce((latLng1, latLng2) => latLng1.concat(latLng2), []);
        this.map.getMapInstance().animateCamera({
          'target': points,
          'duration': 2500
        });
        if (this.callback)
          this.callback(this._approximate, null);
      }*/
    }
  
    getAlign(str:string) {
      if (this.align.indexOf(str) > -1) return true;
      return null;
    }
  }
